var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTopVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1919,
    height: 30,
    viewBox: "0 0 1919 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.0595H10.4442V0L0 17.9405H4.55583V30L15 12.0595Z",
    fill: "#FFA41B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.0595H26.4442V0L16 17.9405H20.5558V30L31 12.0595Z",
    fill: "#FFA41B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 12.0595H42.4442V0L32 17.9405H36.5558V30L47 12.0595Z",
    fill: "#FFA41B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 12.0595H58.4442V0L48 17.9405H52.5558V30L63 12.0595Z",
    fill: "#FFA41B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79 12.0595H74.4442V0L64 17.9405H68.5558V30L79 12.0595Z",
    fill: "#FFA41B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95 12.0595H90.4442V0L80 17.9405H84.5558V30L95 12.0595Z",
    fill: "#FFA41B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111 12.0595H106.444V0L96 17.9405H100.556V30L111 12.0595Z",
    fill: "#FFA41B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127 12.0595H122.444V0L112 17.9405H116.556V30L127 12.0595Z",
    fill: "#FFA41B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143 12.0595H138.444V0L128 17.9405H132.556V30L143 12.0595Z",
    fill: "#FFA41B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159 12.0595H154.444V0L144 17.9405H148.556V30L159 12.0595Z",
    fill: "#FFA41B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175 12.0595H170.444V0L160 17.9405H164.556V30L175 12.0595Z",
    fill: "#FFA41B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M191 12.0595H186.444V0L176 17.9405H180.556V30L191 12.0595Z",
    fill: "#FFA41B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M207 12.0595H202.444V0L192 17.9405H196.556V30L207 12.0595Z",
    fill: "#FFA41B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M223 12.0595H218.444V0L208 17.9405H212.556V30L223 12.0595Z",
    fill: "#FFA41B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239 12.0595H234.444V0L224 17.9405H228.556V30L239 12.0595Z",
    fill: "#FFA41B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M255 12.0595H250.444V0L240 17.9405H244.556V30L255 12.0595Z",
    fill: "#FFA41B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M271 12.0595H266.444V0L256 17.9405H260.556V30L271 12.0595Z",
    fill: "#FFA41B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M287 12.0595H282.444V0L272 17.9405H276.556V30L287 12.0595Z",
    fill: "#FFA41B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M303 12.0595H298.444V0L288 17.9405H292.556V30L303 12.0595Z",
    fill: "#FFA41B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M319 12.0595H314.444V0L304 17.9405H308.556V30L319 12.0595Z",
    fill: "#FFA41B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M335 12.0595H330.444V0L320 17.9405H324.556V30L335 12.0595Z",
    fill: "#FFA41B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M351 12.0595H346.444V0L336 17.9405H340.556V30L351 12.0595Z",
    fill: "#FFA41B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M367 12.0595H362.444V0L352 17.9405H356.556V30L367 12.0595Z",
    fill: "#FFA41B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M383 12.0595H378.444V0L368 17.9405H372.556V30L383 12.0595Z",
    fill: "#FFA41B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M399 12.0595H394.444V0L384 17.9405H388.556V30L399 12.0595Z",
    fill: "#FFA41B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M415 12.0595H410.444V0L400 17.9405H404.556V30L415 12.0595Z",
    fill: "#FFA41B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M431 12.0595H426.444V0L416 17.9405H420.556V30L431 12.0595Z",
    fill: "#FFA41B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M447 12.0595H442.444V0L432 17.9405H436.556V30L447 12.0595Z",
    fill: "#FFA41B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M463 12.0595H458.444V0L448 17.9405H452.556V30L463 12.0595Z",
    fill: "#FFA41B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M479 12.0595H474.444V0L464 17.9405H468.556V30L479 12.0595Z",
    fill: "#FFA41B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M495 12.0595H490.444V0L480 17.9405H484.556V30L495 12.0595Z",
    fill: "#FFA41B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M511 12.0595H506.444V0L496 17.9405H500.556V30L511 12.0595Z",
    fill: "#FFA41B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M527 12.0595H522.444V0L512 17.9405H516.556V30L527 12.0595Z",
    fill: "#FFA41B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M543 12.0595H538.444V0L528 17.9405H532.556V30L543 12.0595Z",
    fill: "#FFA41B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M559 12.0595H554.444V0L544 17.9405H548.556V30L559 12.0595Z",
    fill: "#FFA41B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M575 12.0595H570.444V0L560 17.9405H564.556V30L575 12.0595Z",
    fill: "#FFA41B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M591 12.0595H586.444V0L576 17.9405H580.556V30L591 12.0595Z",
    fill: "#FFA41B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M607 12.0595H602.444V0L592 17.9405H596.556V30L607 12.0595Z",
    fill: "#FFA41B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M623 12.0595H618.444V0L608 17.9405H612.556V30L623 12.0595Z",
    fill: "#FFA41B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M639 12.0595H634.444V0L624 17.9405H628.556V30L639 12.0595Z",
    fill: "#FFA41B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M655 12.0595H650.444V0L640 17.9405H644.556V30L655 12.0595Z",
    fill: "#FFA41B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M671 12.0595H666.444V0L656 17.9405H660.556V30L671 12.0595Z",
    fill: "#FFA41B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M687 12.0595H682.444V0L672 17.9405H676.556V30L687 12.0595Z",
    fill: "#FFA41B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M703 12.0595H698.444V0L688 17.9405H692.556V30L703 12.0595Z",
    fill: "#FFA41B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M719 12.0595H714.444V0L704 17.9405H708.556V30L719 12.0595Z",
    fill: "#FFA41B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M735 12.0595H730.444V0L720 17.9405H724.556V30L735 12.0595Z",
    fill: "#FFA41B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M751 12.0595H746.444V0L736 17.9405H740.556V30L751 12.0595Z",
    fill: "#FFA41B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M767 12.0595H762.444V0L752 17.9405H756.556V30L767 12.0595Z",
    fill: "#FFA41B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M783 12.0595H778.444V0L768 17.9405H772.556V30L783 12.0595Z",
    fill: "#FFA41B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M799 12.0595H794.444V0L784 17.9405H788.556V30L799 12.0595Z",
    fill: "#FFA41B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M815 12.0595H810.444V0L800 17.9405H804.556V30L815 12.0595Z",
    fill: "#FFA41B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M831 12.0595H826.444V0L816 17.9405H820.556V30L831 12.0595Z",
    fill: "#FFA41B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M847 12.0595H842.444V0L832 17.9405H836.556V30L847 12.0595Z",
    fill: "#FFA41B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M863 12.0595H858.444V0L848 17.9405H852.556V30L863 12.0595Z",
    fill: "#FFA41B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M879 12.0595H874.444V0L864 17.9405H868.556V30L879 12.0595Z",
    fill: "#FFA41B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M895 12.0595H890.444V0L880 17.9405H884.556V30L895 12.0595Z",
    fill: "#FFA41B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M911 12.0595H906.444V0L896 17.9405H900.556V30L911 12.0595Z",
    fill: "#FFA41B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M927 12.0595H922.444V0L912 17.9405H916.556V30L927 12.0595Z",
    fill: "#FFA41B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M943 12.0595H938.444V0L928 17.9405H932.556V30L943 12.0595Z",
    fill: "#FFA41B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M959 12.0595H954.444V0L944 17.9405H948.556V30L959 12.0595Z",
    fill: "#FFA41B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M975 12.0595H970.444V0L960 17.9405H964.556V30L975 12.0595Z",
    fill: "#FFA41B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M991 12.0595H986.444V0L976 17.9405H980.556V30L991 12.0595Z",
    fill: "#FFA41B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1007 12.0595H1002.44V0L992 17.9405H996.556V30L1007 12.0595Z",
    fill: "#FFA41B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1023 12.0595H1018.44V0L1008 17.9405H1012.56V30L1023 12.0595Z",
    fill: "#FFA41B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1039 12.0595H1034.44V0L1024 17.9405H1028.56V30L1039 12.0595Z",
    fill: "#FFA41B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1055 12.0595H1050.44V0L1040 17.9405H1044.56V30L1055 12.0595Z",
    fill: "#FFA41B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1071 12.0595H1066.44V0L1056 17.9405H1060.56V30L1071 12.0595Z",
    fill: "#FFA41B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1087 12.0595H1082.44V0L1072 17.9405H1076.56V30L1087 12.0595Z",
    fill: "#FFA41B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1103 12.0595H1098.44V0L1088 17.9405H1092.56V30L1103 12.0595Z",
    fill: "#FFA41B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1119 12.0595H1114.44V0L1104 17.9405H1108.56V30L1119 12.0595Z",
    fill: "#FFA41B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1135 12.0595H1130.44V0L1120 17.9405H1124.56V30L1135 12.0595Z",
    fill: "#FFA41B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1151 12.0595H1146.44V0L1136 17.9405H1140.56V30L1151 12.0595Z",
    fill: "#FFA41B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1167 12.0595H1162.44V0L1152 17.9405H1156.56V30L1167 12.0595Z",
    fill: "#FFA41B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1183 12.0595H1178.44V0L1168 17.9405H1172.56V30L1183 12.0595Z",
    fill: "#FFA41B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1199 12.0595H1194.44V0L1184 17.9405H1188.56V30L1199 12.0595Z",
    fill: "#FFA41B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1215 12.0595H1210.44V0L1200 17.9405H1204.56V30L1215 12.0595Z",
    fill: "#FFA41B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1231 12.0595H1226.44V0L1216 17.9405H1220.56V30L1231 12.0595Z",
    fill: "#FFA41B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1247 12.0595H1242.44V0L1232 17.9405H1236.56V30L1247 12.0595Z",
    fill: "#FFA41B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1263 12.0595H1258.44V0L1248 17.9405H1252.56V30L1263 12.0595Z",
    fill: "#FFA41B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1279 12.0595H1274.44V0L1264 17.9405H1268.56V30L1279 12.0595Z",
    fill: "#FFA41B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1295 12.0595H1290.44V0L1280 17.9405H1284.56V30L1295 12.0595Z",
    fill: "#FFA41B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1311 12.0595H1306.44V0L1296 17.9405H1300.56V30L1311 12.0595Z",
    fill: "#FFA41B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1327 12.0595H1322.44V0L1312 17.9405H1316.56V30L1327 12.0595Z",
    fill: "#FFA41B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1343 12.0595H1338.44V0L1328 17.9405H1332.56V30L1343 12.0595Z",
    fill: "#FFA41B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1359 12.0595H1354.44V0L1344 17.9405H1348.56V30L1359 12.0595Z",
    fill: "#FFA41B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1375 12.0595H1370.44V0L1360 17.9405H1364.56V30L1375 12.0595Z",
    fill: "#FFA41B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1391 12.0595H1386.44V0L1376 17.9405H1380.56V30L1391 12.0595Z",
    fill: "#FFA41B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1407 12.0595H1402.44V0L1392 17.9405H1396.56V30L1407 12.0595Z",
    fill: "#FFA41B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1423 12.0595H1418.44V0L1408 17.9405H1412.56V30L1423 12.0595Z",
    fill: "#FFA41B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1439 12.0595H1434.44V0L1424 17.9405H1428.56V30L1439 12.0595Z",
    fill: "#FFA41B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1455 12.0595H1450.44V0L1440 17.9405H1444.56V30L1455 12.0595Z",
    fill: "#FFA41B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1471 12.0595H1466.44V0L1456 17.9405H1460.56V30L1471 12.0595Z",
    fill: "#FFA41B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1487 12.0595H1482.44V0L1472 17.9405H1476.56V30L1487 12.0595Z",
    fill: "#FFA41B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1503 12.0595H1498.44V0L1488 17.9405H1492.56V30L1503 12.0595Z",
    fill: "#FFA41B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1519 12.0595H1514.44V0L1504 17.9405H1508.56V30L1519 12.0595Z",
    fill: "#FFA41B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1535 12.0595H1530.44V0L1520 17.9405H1524.56V30L1535 12.0595Z",
    fill: "#FFA41B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1551 12.0595H1546.44V0L1536 17.9405H1540.56V30L1551 12.0595Z",
    fill: "#FFA41B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1567 12.0595H1562.44V0L1552 17.9405H1556.56V30L1567 12.0595Z",
    fill: "#FFA41B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1583 12.0595H1578.44V0L1568 17.9405H1572.56V30L1583 12.0595Z",
    fill: "#FFA41B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1599 12.0595H1594.44V0L1584 17.9405H1588.56V30L1599 12.0595Z",
    fill: "#FFA41B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1615 12.0595H1610.44V0L1600 17.9405H1604.56V30L1615 12.0595Z",
    fill: "#FFA41B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1631 12.0595H1626.44V0L1616 17.9405H1620.56V30L1631 12.0595Z",
    fill: "#FFA41B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1647 12.0595H1642.44V0L1632 17.9405H1636.56V30L1647 12.0595Z",
    fill: "#FFA41B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1663 12.0595H1658.44V0L1648 17.9405H1652.56V30L1663 12.0595Z",
    fill: "#FFA41B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1679 12.0595H1674.44V0L1664 17.9405H1668.56V30L1679 12.0595Z",
    fill: "#FFA41B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1695 12.0595H1690.44V0L1680 17.9405H1684.56V30L1695 12.0595Z",
    fill: "#FFA41B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1711 12.0595H1706.44V0L1696 17.9405H1700.56V30L1711 12.0595Z",
    fill: "#FFA41B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1727 12.0595H1722.44V0L1712 17.9405H1716.56V30L1727 12.0595Z",
    fill: "#FFA41B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1743 12.0595H1738.44V0L1728 17.9405H1732.56V30L1743 12.0595Z",
    fill: "#FFA41B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1759 12.0595H1754.44V0L1744 17.9405H1748.56V30L1759 12.0595Z",
    fill: "#FFA41B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1775 12.0595H1770.44V0L1760 17.9405H1764.56V30L1775 12.0595Z",
    fill: "#FFA41B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1791 12.0595H1786.44V0L1776 17.9405H1780.56V30L1791 12.0595Z",
    fill: "#FFA41B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1807 12.0595H1802.44V0L1792 17.9405H1796.56V30L1807 12.0595Z",
    fill: "#FFA41B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1823 12.0595H1818.44V0L1808 17.9405H1812.56V30L1823 12.0595Z",
    fill: "#FFA41B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1839 12.0595H1834.44V0L1824 17.9405H1828.56V30L1839 12.0595Z",
    fill: "#FFA41B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1855 12.0595H1850.44V0L1840 17.9405H1844.56V30L1855 12.0595Z",
    fill: "#FFA41B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1871 12.0595H1866.44V0L1856 17.9405H1860.56V30L1871 12.0595Z",
    fill: "#FFA41B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1887 12.0595H1882.44V0L1872 17.9405H1876.56V30L1887 12.0595Z",
    fill: "#FFA41B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1903 12.0595H1898.44V0L1888 17.9405H1892.56V30L1903 12.0595Z",
    fill: "#FFA41B"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1919 12.0595H1914.44V0L1904 17.9405H1908.56V30L1919 12.0595Z",
    fill: "#FFA41B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTopVector);
export default __webpack_public_path__ + "static/media/footer-top-vector.768bf943652301f7fd500e1968541da7.svg";
export { ForwardRef as ReactComponent };